import React, { useState, useRef } from "react";
import PropTypes from "prop-types";
import { Mutation } from "@apollo/client/react/components";
import { gql } from "@apollo/client";

const HORemoveFromContractBtn = ({ contractId, userId, params }) => {
  const [disabled, setDisabled] = useState(false);
  const rowIdRef = useRef(null);

  const onClick = update => {
    if (
      window.confirm(
        "This will remove the user from this contract, are you sure?"
      )
    ) {
      rowIdRef.current = params.node.id;
      setDisabled(true);
      update({
        variables: {
          id: contractId,
          userId: userId
        }
      });
    }
  };

  const onError = ({ graphQLErrors, networkError }) => {
    console.log("onError occurred");
    console.log(graphQLErrors);
    console.log(networkError);
    setDisabled(false);
    rowIdRef.current = null;
  };

  const onCompleted = data => {
    if (data.removeUserFromContract.userRemoved && rowIdRef.current != null) {
      params.api.applyServerSideTransaction({
        remove: [{ id: rowIdRef.current }]
      });
      rowIdRef.current = null;
    }
  };

  return (
    <Mutation
      mutation={REMOVE_FROM_CONTRACT}
      onError={onError}
      onCompleted={onCompleted}
    >
      {update => (
        <button
          onClick={() => onClick(update)}
          className="button button--small red"
          disabled={disabled}
        >
          Remove from contract
        </button>
      )}
    </Mutation>
  );
};

HORemoveFromContractBtn.propTypes = {
  contractId: PropTypes.number.isRequired,
  userId: PropTypes.number.isRequired,
  params: PropTypes.object.isRequired
};

export default HORemoveFromContractBtn;

const REMOVE_FROM_CONTRACT = gql`
  mutation removeUserFromContract($id: ID!, $userId: ID!) {
    removeUserFromContract(id: $id, userId: $userId) {
      userRemoved
      id
    }
  }
`;
